





















































import { Component, Vue } from 'vue-property-decorator';
import BookingWizardDetails from '@/components/Bookings/BookingWizardDetails.vue'
import BookingWizardRequirements from '@/components/Bookings/BookingWizardRequirements.vue'
import BookingWizardReview from '@/components/Bookings/BookingWizardReview.vue'
import BookingWizardComplete from '@/components/Bookings/BookingWizardComplete.vue'
import Alert from '@/components/Shared/Alert.vue';
import { BookingWizardModule } from '@/store/modules/bookingWizard';
import PageNames from '@/router/PageNames';
import GiganautVue from '@/components/Shared/GiganautVue';

@Component({
  name: 'BookingWizard',
  components: { Alert, BookingWizardDetails, BookingWizardRequirements, BookingWizardReview, BookingWizardComplete }
})
export default class extends GiganautVue {

  get currentStep() {
    return BookingWizardModule.newBooking.currentStep;
  }

  get nextButtonName() {
    return (this.currentStep === 3) ? "Create": "Next";
  }

  get step() {
    return this.currentStep;
  }

  set step(value) {
    if (this.currentStep != value) {
      BookingWizardModule.newBooking.currentStep = value;
    }
  }

  get showBackButton() {
    return this.currentStep === 3 || this.currentStep === 2
  }

  get showNextButton() {
    return this.currentStep !== 4
  }

  get currentCompany() {
    return BookingWizardModule.newBookingOptions.company;
  }

  get loading() {
    return BookingWizardModule.loading;
  }

  async backClick() {
    this.step -= 1
  }

  async nextClick() {
    if (this.currentStep === 1) { 
      if (await(this.$refs.bookingDetails as any).validateForm()) {
        return;
      }
      //Stupid work around until date picker validation works
      if (BookingWizardModule.newBooking.dates.length == 0) {
        await(this.$refs.bookingDetails as any).validateDatesFailed(true);
        return;
      }
      else {
        await(this.$refs.bookingDetails as any).validateDatesFailed(false);
      }
    }
    else if (this.currentStep === 2) { 
      if (await(this.$refs.bookingRequirements as any).validateForm()) {
        return;
      }
    }
    else if (this.currentStep === 3){
      //Create new booking
      await BookingWizardModule.createNewBooking();
      if (BookingWizardModule.isError) {
        return;
      }
    }
    this.step += 1;
  }
}
